<template>
  <el-dialog
    v-dialogDrag
    custom-class="select-customer-modal"
    :visible.sync="visible"
    width="460px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="close"
  >
    <template #title>
      <div class="select-customer-modal__title">确认转接</div>
    </template>

    <div class="select-customer-modal__body">
      <div class="customer-card">
        <div class="customer-card__avatar">
          <head-image
            :id="customer.id"
            :name="displayName"
            :url="customer.headImage || customer.headImageThumb"
            :size="56"
            radius="50%"
            :online="Boolean(customer.online)"
            :isShowUserInfo="false"
          />
        </div>
        <div class="customer-card__content">
          <div class="customer-card__label">目标客服</div>
          <div class="customer-card__name">{{ displayName }}</div>
          <div class="customer-card__status" :class="{ 'is-online': customer.online }">
            {{ customer.online ? "当前在线" : "当前离线" }}
          </div>
        </div>
      </div>

      <div class="reason-block">
        <div class="reason-block__label">转接原因</div>
        <el-input v-model="reason" type="textarea" :rows="4" maxlength="200" show-word-limit resize="none" placeholder="请输入转接原因" />
      </div>
    </div>

    <template #footer>
      <div class="select-customer-modal__footer">
        <el-button @click="close">取消</el-button>
        <el-button :loading="loading" :disabled="loading" type="primary" @click="handleConfirm">确认转接</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "SelectCustomerModal",
  components: {
    HeadImage
  },
  data() {
    return {
      visible: false,
      customer: {},
      reason: "",
      loading: false
    };
  },
  computed: {
    displayName() {
      return this.customer.nickName || this.customer.userName || "--";
    }
  },
  methods: {
    open(customer) {
      this.customer = customer || {};
      this.reason = "";
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleConfirm() {
      const reason = this.reason.trim();
      if (!reason) {
        this.$message.warning("请输入转接原因");
        return;
      }
      this.applyTransfer();
      // this.$emit("confirm", {
      //   customer: this.customer,
      //   reason
      // });
      // console.log("dasdasdasdasd", this.customer.chatId, this.customer.id);

      this.close();
    },
    // 申请转接接口
    applyTransfer() {
      this.loading = true;
      this.$http({
        url: "/customer/transfer/apply",
        method: "POST",
        data: {
          userId: this.customer.chatId, // 访客用户ID
          transferReason: this.reason, // 转接原因
          toUserId: this.customer.id //目标客服ID
        }
      })
        .then((res) => {
          this.$message.success("转接成功");
          this.$emit("confirm", {
            customer: this.customer
          });
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.select-customer-modal__title {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}

.select-customer-modal__body {
  padding-top: 4px;
}

.customer-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.customer-card__avatar {
  flex-shrink: 0;
}

.customer-card__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.customer-card__label {
  font-size: 12px;
  color: #64748b;
  line-height: 1;
}

.customer-card__name {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.3;
  word-break: break-all;
}

.customer-card__status {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  line-height: 1;
}

.customer-card__status.is-online {
  background: rgba(68, 165, 255, 0.2);
  color: #00528b;
}

.reason-block {
  margin-top: 18px;
}

.reason-block__label {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.reason-block :deep(.el-textarea__inner) {
  min-height: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  border-color: #dbe4f0;
  background: #fbfdff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    background: #ffffff;
  }
}

.select-customer-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

:deep(.select-customer-modal) {
  border-radius: 18px;
  overflow: hidden;
}

:deep(.select-customer-modal .el-dialog__header) {
  padding: 22px 24px 10px;
}

:deep(.select-customer-modal .el-dialog__body) {
  padding: 0 24px 12px;
}

:deep(.select-customer-modal .el-dialog__footer) {
  padding: 8px 24px 24px;
}
</style>
